class UtilService {
    /**
     * 문자열을 휴대폰 번호 포맷으로 변환
     *
     * @param str 소스 문자열
     * @returns {string|*} 'nnn-nnnn-nnnn' 형태로 변환된 휴대폰 번호
     */
    humanReadableMobile(str) {
        if (!str) return '';

        str = str.replace(/[^0-9]/g, '');
        let tmp = '';

        if (str.length < 4) {
            return str;
        } else if (str.length < 7) {
            tmp += str.substr(0, 3);
            tmp += '-';
            tmp += str.substr(3);
            return tmp;
        } else if (str.length < 11) {
            tmp += str.substr(0, 3);
            tmp += '-';
            tmp += str.substr(3, 3);
            tmp += '-';
            tmp += str.substr(6);
            return tmp;
        } else {
            tmp += str.substr(0, 3);
            tmp += '-';
            tmp += str.substr(3, 4);
            tmp += '-';
            tmp += str.substr(7);
            return tmp;
        }
    }

    normalizeMobile(str) {
        if (!str) return '';

        return str.replace(/-/g, '');
    }

    /**
     * v4 uuid 생성 (length: 36)
     *
     * @returns {string}
     */
    uuid() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            let r = Math.random() * 16 | 0
            let v = c == 'x' ? r : (r & 0x3 | 0x8);

            return v.toString(16);
        });
    }

    /**
     * 휴대폰 번호 검증
     *
     * @param mobile 휴대폰 번호
     * @returns {string|boolean} 정상이면 true, 아니면 오류 문자열
     */
    validateMobile(mobile) {
        if (mobile) {
            const re = /(01[016789])[-]?(\d{3,4})[-]?(\d{4})$/g;
            const match = re.exec(mobile);
            if (match) {
                return true;
            }
        }

        return '정확한 휴대폰 번호를 입력하세요';
    }

    /**
     * 차량 번호 검증
     *
     * @param carNumber 차량 번호
     * @returns {boolean|string} 정상이면 true, 아니면 오류 문자열
     */
    validateCarNum(carNumber) {
        if (carNumber) {
            const re = /(\d{2,3})([가-힝])(\d{4})$/g;
            const match = re.exec(carNumber);
            return match ? true : '정확한 차량 번호를 입력하세요';
        } else {
            return true;
        }
    }

    deepcopy(origin) {
        try {
            return JSON.parse(JSON.stringify(origin));
        } catch(err) {
            return origin;
        }
    }
}

export default new UtilService()